import { render, staticRenderFns } from "./ElecNotice.vue?vue&type=template&id=e49dccb0&scoped=true"
import script from "./ElecNotice.vue?vue&type=script&lang=js"
export * from "./ElecNotice.vue?vue&type=script&lang=js"
import style0 from "./ElecNotice.vue?vue&type=style&index=0&id=e49dccb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e49dccb0",
  null
  
)

export default component.exports